@let cards = this.filteredCards();
@let expanded = this.expandedId();
@let cultureMenu = this.cultureMenu();

<div
  class="palette flex-column g-space-md"
  (keydown.arrowdown)="this.moveExpanded(1); $event.preventDefault()"
  (keydown.arrowup)="this.moveExpanded(-1); $event.preventDefault()"
  (keydown.enter)="this.applyExpanded()"
>
  <div #paletteHeader class="palette__header flex-column g-space-sm">
    <cam-search-field
      [isOpen]="true"
      placeholder="communication.filters.template"
      [input]="this.inputSearch"
      [standalone]="true"
    ></cam-search-field>

    @if (cultureMenu) {
      <cam-menu-navigation
        [menu]="cultureMenu"
        container="tags"
        [options]="{
          spaceElement: 'xs',
        }"
      ></cam-menu-navigation>
    }
  </div>

  <cam-loader [isLoading]="this.requestState.isLoading()">
    <cam-error [message]="this.requestState.getErrorMessage()" [code]="this.requestState.getErrorStatus()">
      <cam-empty [isEmpty]="cards.length === 0">
        <div class="palette__list grid g-space-md">
          @for (card of cards; track card.template.id) {
            @let isExpanded = expanded === card.template.id;

            <!-- deux colonnes, sauf la carte dépliée qui prend la ligne entière -->
            <!-- le clic est porté par ce conteneur : l'output click de cam-card n'émet jamais -->
            <div
              #cardElement
              class="c-pointer md-full"
              [class.one-half]="!isExpanded"
              [class.full]="isExpanded"
              (click)="this.toggle(card)"
            >
              <cam-card type="primary" [interactive]="true" [selected]="isExpanded" [fullHeight]="true">
                <cam-card-header>
                  @if (card.isRecent || card.documentsCount > 0) {
                    <cam-card-tag>
                      <div class="flex-row align-center g-space-xs">
                        @if (card.isRecent) {
                          <cam-badge value="communication.template.choice.recent" type="info" size="xs"></cam-badge>
                        }
                        @if (card.documentsCount > 0) {
                          <cam-badge
                            icon="attach"
                            [value]="card.documentsCount.toString()"
                            type="secondary"
                            size="xs"
                          ></cam-badge>
                        }
                      </div>
                    </cam-card-tag>
                  }

                  <cam-card-title>
                    <div class="card__heading flex-row align-center space-between g-space-sm">
                      <span class="card__name">{{ card.title }}</span>

                      @if (isExpanded) {
                        <cam-button size="sm" (action)="this.apply(card)">
                          {{ 'communication.template.detail.cta' | translate }}
                        </cam-button>
                      }
                    </div>
                  </cam-card-title>
                  <cam-card-subtitle>
                    <span class="card__code">{{ card.template.code }}</span>
                  </cam-card-subtitle>
                </cam-card-header>

                <cam-card-content>
                  @if (isExpanded) {
                    <cam-choice-detail [variant]="card.variant"></cam-choice-detail>
                  } @else if (card.snippet) {
                    <cam-text class="card__snippet" size="sm">{{ card.snippet }}</cam-text>
                  }
                </cam-card-content>
              </cam-card>
            </div>
          }
        </div>
      </cam-empty>
    </cam-error>
  </cam-loader>
</div>
